module.exports = __webpack_public_path__ + "image/solution_list_img1.jpg";